import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChatInternalService } from '../../../services/chat-internal.service';
import { M_SendMessageRequest, M_SendMessageResponse } from '../../../models/M_ChatInternal';

interface MessageSentEvent extends M_SendMessageResponse {
  userMessage: string;
}

@Component({
  selector: 'app-chat-internal-input',
  templateUrl: './chat-internal-input.component.html',
  styleUrls: ['./chat-internal-input.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatIconButton, MatProgressSpinnerModule],
})
export class ChatInternalInputComponent {
  @Input() conversationId: number | null = null;
  @Output() messageSent = new EventEmitter<MessageSentEvent>();

  message = '';
  sending = false;

  private chatService = inject(ChatInternalService);

  sendMessage(): void {
    if (!this.message.trim() || this.sending) return;

    const request: M_SendMessageRequest = {
      conversation_id: this.conversationId,
      message: this.message.trim(),
    };

    const userMessage = this.message.trim();
    this.sending = true;
    this.chatService.sendMessage(request).subscribe({
      next: (r) => {
        this.message = '';
        this.sending = false;
        this.messageSent.emit({ ...r.data, userMessage });
      },
      error: () => {
        this.sending = false;
      },
    });
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }
}
